// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1wM8o","footer":"ModalUpdate_footer__fgjRc"};